import { useState } from 'react';
import {
    PayPalScriptProvider,
    PayPalButtons,
    ReactPayPalScriptOptions,
} from '@paypal/react-paypal-js';
import { ErrorMessageTitle, ErrorMessageWrapper } from '../ErrorMessage/ErrorMessage.styles';
import { fetchPaypalOrder } from '@/entities/Checkout/service/fetchPaypalOrder';
import { isProd } from '@/common/app/constants/envs';
import { PAYPAL_CLIENT_ID } from '@/common/app/constants/keys';

type TPayPal = {
    totalAmount: number;
    sessionId: string;
    isDark?: boolean;
    disabled?: boolean;
    submitHandler: (paypalOrderId: string) => Promise<'success' | 'fail'>;
};

export const PayPal = ({
    /* isDark, totalAmount, */ sessionId,
    disabled,
    submitHandler,
}: TPayPal) => {
    const initialOptions: ReactPayPalScriptOptions = {
        clientId: PAYPAL_CLIENT_ID,
        currency: 'USD',
        components: ['buttons' /* , 'messages' */],
        intent: 'capture',
        enableFunding: ['paylater', 'venmo', 'credit'],
        disableFunding: 'card',
        environment: isProd ? 'production' : 'sandbox',
        ...(!isProd && { buyerCountry: 'US' }),
    };

    const [message, setMessage] = useState('');

    return (
        <div style={{ marginTop: '6px', position: 'relative', zIndex: 0 }}>
            <PayPalScriptProvider options={initialOptions}>
                <PayPalButtons
                    style={{
                        shape: 'rect',
                        layout: 'vertical',
                        color: 'silver',
                        label: 'paypal',
                        height: 40,
                        tagline: false,
                    }}
                    /* message={{
                        amount: totalAmount,
                        align: 'center',
                        color: isDark ? 'white' : 'black',
                        position: 'bottom',
                        offer: 'pay_later_short_term',
                    }} */
                    createOrder={async () => {
                        if (disabled) {
                            setMessage('Please fill the contact info form.');
                            return '';
                        }
                        try {
                            const orderData = await fetchPaypalOrder({ session_id: sessionId });

                            if (orderData.data.pp_order_id) {
                                return orderData.data.pp_order_id;
                            } else {
                                throw new Error(orderData.errors[0]);
                            }
                        } catch (error) {
                            console.error(error);
                            setMessage(`Could not initiate PayPal Checkout...${error}`);
                        }

                        return '';
                    }}
                    onApprove={async (data: { orderID: string } /* actions */) => {
                        try {
                            const res = await submitHandler(data.orderID);

                            if (res === 'success') {
                                setMessage(
                                    `Transaction SUCCESS: Thank You. Your adventure awaits.`
                                );
                            } else {
                                setMessage("We couldn't complete your payment.");
                            }
                        } catch (error) {
                            console.error(error);
                            setMessage(`Sorry, your transaction could not be processed...${error}`);
                        }
                    }}
                />
            </PayPalScriptProvider>
            {message && (
                <ErrorMessageWrapper>
                    <ErrorMessageTitle>{message}</ErrorMessageTitle>
                </ErrorMessageWrapper>
            )}
        </div>
    );
};
